<template>
<section>
  <h1>DUMP Days prošle godine</h1>
  <div class="grid-container">
    <div class="a text cyan">
      <div class="tekst">
        1100
        <span>posjetitelja</span>
      </div>
    </div>
    <div class="b">
      <img src="../../assets/grid/robot.jpg" alt="Robot">
    </div>
    <div class="c">
      <img src="../../assets/grid/chill.jpg" alt="Odmor">
    </div>
    <div class="d">
      <img src="../../assets/grid/food.jpg" alt="Hrana">
    </div>
    <div class="e text navy">
      <div class="tekst">
        1
        <span>escape room</span>
      </div>
    </div>
    <div class="f">
      <img src="../../assets/grid/darts.jpg" alt="Pikado">
    </div>
    <div class="r">
      <img src="../../assets/grid/games.jpg" alt="Igre">
    </div>
    <div class="t text red">
      <div class="tekst">
        140
        <span>jumbo pizza</span>
      </div>
    </div>
    <div class="g">
      <img src="../../assets/grid/panel.jpg" alt="Panel">
      <div class="parent">
        <img class="quote" src="../../assets/icons/quotes.svg" alt="Citat">
      </div>
    </div>
    <div class="h">
      <img src="../../assets/grid/workshop.jpg" alt="Radionica">
    </div>
    <div class="z">
      <div>
        <div class="citat">
          <p>Okupljanje organizirano na ovolikoj razini sa silnom pozitivnom energijom i duhom koji se očituje u svakoj sitnici je današnjim mladim generacijama upravo ona dodatna stepenica za potaknuti kreativnost i otvoriti oči što se to sve događa oko njih, ali i spojiti ih s potencijalno jako konkretnim poslovnim ponudama.</p>
          <div>
            <b>Vladan Strigo</b>
            <span>CEO @Netmedia</span>
          </div>
        </div>
      </div>
    </div>
    <div class="A">
      <img src="../../assets/grid/cards.jpg" alt="Karte">
      <div class="parent">
        <img class="quote" src="../../assets/icons/quotes.svg" alt="Citat">
      </div>
    </div>
    <div class="B">
      <img src="../../assets/grid/mingle.jpg" alt="Druženje">
    </div>
    <div class="D">
      <div>
        <div class="citat">
          <p>Svake godine ekipa iz DUMP-a pripremi nešto novo i zanimljivo. Ono što je započelo kao maleni lokalni event, pretvara se u digitalnu konferenciju koja može stati uz bok najboljim IT događajima u državi.</p>
          <div>
            <b>Miro Marasović</b>
            <span>Product Strategy Lead @Profico</span>
          </div>
        </div>
      </div>
    </div>
    <div class="Z">
      <img src="../../assets/grid/award.jpg" alt="Nagrada">
    </div>
    <div class="X">
      <div class="parent">
        <img class="quote" src="../../assets/icons/quotes.svg" alt="Citat">
      </div>
    </div>
    <div class="U">
      <div>
        <div class="citat">
          <p>Okupljanje organizirano na ovolikoj razini sa silnom pozitivnom energijom i duhom koji se očituje u svakoj sitnici je današnjim mladim generacijama upravo ona dodatna stepenica za potaknuti kreativnost i otvoriti oči što se to sve događa oko njih, ali i spojiti ih s potencijalno jako konkretnim poslovnim ponudama.</p>
          <div>
            <b>Vladan Strigo</b>
            <span>CEO @Netmedia</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<style scoped>
h1 {
  font-family: "Fuse V.2 Display";
  font-weight: 800;
  font-size: 36px;
  padding-left: 10%;
  margin-top: 150px;
  margin-bottom: 20px;
}

.text {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-wrap: wrap;
}

.text > div {
  top: 50% !important;
  transform: translateY(-50%);
  color: #ffffff;
  font-family: "Fuse V.2 Display";
  font-size: 40px;
  font-weight: 800;
  line-height: 100%;
}

.text > div > span {
  font-family: "Fuse V.2 Display";
  font-size: 14px;
  font-weight: 800;
  text-transform: uppercase;
  display: block;
}

.citat {
  display: flex;
  flex-direction: column;
  align-items: space-between;
}

.citat > * {
  margin-top: 10px;
}

.citat > p {
  color: rgba(0, 0, 0, 0.6);
  font-family: "Fuse V.2 Display";
  font-size: 16px;
  line-height: 20px;
}

.citat > div > b {
  color: #000000;
  font-family: "Fuse V.2 Display";
  font-size: 14px;
  font-weight: 800;
  line-height: 15px;
}

.citat > div > span {
  color: rgba(0, 0, 0, 0.55);
  font-family: "Fuse V.2 Display";
  font-size: 12px;
  line-height: 10px;
  display: table;
}

.cyan {
  background-color: #30cec1;
}

.red {
  background-color: #ff575f;
}

.navy {
  background-color: #2c373f;
}

.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-areas: ". a ." "b c c" ". c c" "d . e" ". f ." "r . t" ". g g" "h g g" ". z z";
}

.grid-container > div {
  padding-top: 50%;
  width: 100%;
  position: relative;
}

.grid-container > div > * {
  position: absolute;
  top: 0;
  width: 100%;
  left: 0;
  max-width: 100%;
  right: 0;
  object-fit: cover;
}

.a {
  grid-area: a;
}

.b {
  grid-area: b;
}

.c {
  grid-area: c;
}

.d {
  grid-area: d;
}

.r {
  grid-area: r;
}

.t {
  grid-area: t;
}

.e {
  grid-area: e;
}

.f {
  grid-area: f;
}

.g {
  grid-area: g;
}

.h {
  grid-area: h;
}

.z {
  grid-area: z;
}

.i {
  grid-area: i;
}

.j {
  grid-area: j;
}

.k {
  grid-area: k;
}

.A,
.B,
.Z,
.X,
.D,
.U {
  display: none;
}

.grid-container > div .parent {
  position: relative;
  position: absolute;
  top: auto;
  bottom: 0;
  left: 0;
  background-color: #30cec1;
  height: 50px;
  width: 50px;
  padding: 15px 9px;
}

@media screen and (min-width: 420px) {
  .text > div > span {
    font-size: 20px;
  }
}

@media screen and (min-width: 768px) {
  h1 {
    font-size: 54px;
  }

  .text > div {
    font-size: 60px;
  }

  .text > div > span {
    font-size: 40px;
  }

  .citat > * {
    max-width: 350px;
    margin-top: 20px;
  }

  .citat > p {
    font-size: 20px;
    line-height: 24px;
  }

  .citat > div > b {
    font-size: 23px;
    line-height: 22px;
  }

  .citat > div > span {
    font-size: 16px;
    line-height: 20px;
  }
}

@media screen and (min-width: 1100px) {
  h1 {
    margin-bottom: -80px;
  }
}

@media screen and (min-width: 1024px) {
  .grid-container {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-template-areas: ". . . . . c c" ". a . b . c c" "d f f . t . ." ". f f r . h h" "g . e . Z X X" ". A . B . D D" ". U U . . . .";
  }

  .text > div {
    font-size: 55px;
    font-weight: 800;
  }

  .text > div > span {
    font-size: 24px;
  }

  .citat {
    display: flex;
    flex-direction: column;
    align-items: space-between;
  }

  .citat > * {
    max-width: 350px;
    margin-top: 20px;
  }

  .citat > p {
    font-size: 20px;
    line-height: 24px;
  }

  .citat > div > b {
    font-size: 23px;
    line-height: 22px;
  }

  .citat > div > span {
    font-size: 16px;
    line-height: 20px;
  }

  .A,
  .B,
  .Z,
  .X,
  .D,
  .U {
    display: block;
  }

  .A {
    grid-area: A;
  }
  .B {
    grid-area: B;
  }
  .Z {
    grid-area: Z;
  }
  .X {
    grid-area: X;
  }
  .D {
    grid-area: D;
  }
  .U {
    grid-area: U;
  }

  .g .parent {
    display: none;
  }
}
</style>

<script>
export default {
  name: "Grid"
};
</script>
